import React from 'react';
import Modal from './Modal';

const LocationPreferenceDialog = ({ isOpen, onClose, onSelectPreference }) => {
    const handleSelectCurrent = () => {
        onSelectPreference('current');
        onClose();
    };

    const handleSelectSaved = () => {
        onSelectPreference('saved');
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={() => {}} hideCloseButton={true}>
            <div style={{ textAlign: 'center', padding: '1rem' }}>
                <div style={{ marginBottom: '1.5rem' }}>
                    <i className="fas fa-map-marker-alt" style={{ 
                        fontSize: '3rem', 
                        color: '#2563eb',
                        marginBottom: '1rem',
                        display: 'block'
                    }}></i>
                    <h2 style={{ 
                        fontSize: '1.5rem', 
                        fontWeight: '600',
                        color: '#1f2937',
                        marginBottom: '1rem'
                    }}>
                        Location Preference
                    </h2>
                    <p style={{ 
                        color: '#6b7280',
                        fontSize: '1rem',
                        lineHeight: '1.5'
                    }}>
                        To show you the most relevant job opportunities, we'd like to know your location preference. Which location would you like to see jobs for?
                    </p>
                </div>

                <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    gap: '1rem',
                    marginTop: '2rem'
                }}>
                    <button 
                        onClick={handleSelectSaved}
                        style={{
                            padding: '1rem',
                            backgroundColor: '#2563eb',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: '1rem',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '0.5rem'
                        }}
                        onMouseOver={e => e.currentTarget.style.backgroundColor='#1d4ed8'}
                        onMouseOut={e => e.currentTarget.style.backgroundColor='#2563eb'}
                    >
                        <i className="fas fa-home"></i>
                        <span>Base Location</span>
                    </button>

                    <button 
                        onClick={handleSelectCurrent}
                        style={{
                            padding: '1rem',
                            backgroundColor: '#ffffff',
                            color: '#2563eb',
                            border: '2px solid #2563eb',
                            borderRadius: '8px',
                            fontSize: '1rem',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '0.5rem'
                        }}
                        onMouseOver={e => {
                            e.currentTarget.style.backgroundColor='#eff6ff';
                            e.currentTarget.style.borderColor='#1d4ed8';
                        }}
                        onMouseOut={e => {
                            e.currentTarget.style.backgroundColor='#ffffff';
                            e.currentTarget.style.borderColor='#2563eb';
                        }}
                    >
                        <i className="fas fa-location-arrow"></i>
                        <span>Current Location</span>
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default LocationPreferenceDialog;